export enum Mode {
    CREATE,
    DELETE,
    FIND,
    CHECK,
    MANAGE,
    STATS,
    NAVIGATION
}
